import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  BtPayContext,
  CreatePaymentAccountRequestV1,
  CreatePaymentAccountResponseV1,
  GetAllPaymentAccountsResponseV1,
  UpdatePaymentAccountExpirationDateRequestV1,
} from '../models';

export abstract class PaymentAccountsService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('paymentAccountsServiceUrl');
  }

  public abstract createPaymentAccountV1(
    tenantId: string,
    createAccountRequest: CreatePaymentAccountRequestV1,
    sendNotifications?: boolean,
  ): Observable<CreatePaymentAccountResponseV1>;

  public abstract deletePaymentAccount(
    tenantId: string,
    paymentAccountIdentifierBurn: string,
    btPayContext: BtPayContext,
  ): Observable<void>;

  public abstract getAllPaymentAccountsV1(
    tenantId: string,
    buyerAccount: string,
    btPayContext: BtPayContext,
  ): Observable<GetAllPaymentAccountsResponseV1>;

  public abstract getAllPaymentAccountsV1ByUsers(
    tenantId: string,
    buyerAccount: string,
    btPayContext: BtPayContext,
    externalUserUrn: string,
  ): Observable<GetAllPaymentAccountsResponseV1>;

  public abstract updateExpirationDateV1(
    tenantId: string,
    paymentAccountBurn: string,
    updateExpirationRequest: UpdatePaymentAccountExpirationDateRequestV1,
  ): Observable<void>;
}
